import React, { PropsWithChildren, useMemo } from "react"

import { useFrontendConfig } from "@cirrus/common/FrontendConfig"
import { AxiosService } from "@cirrus/core/http/implementations/AxiosService"
import { HttpServiceProvider } from "@cirrus/core/http/provider"
import { withRoot } from "@cirrus/core/http/url/withRoot"

export const HttpDecorator = ({ children }: PropsWithChildren) => {
  const config = useFrontendConfig()

  const axiosService = useMemo(() => {
    const getToken = () => sessionStorage.getItem(config.TokenKey) ?? ""
    const makeUrl = (relativeUrl: string) => withRoot(relativeUrl)

    return new AxiosService(getToken, makeUrl)
  }, [config])

  return <HttpServiceProvider service={axiosService} {...{ children }} />
}
